import { TotalValoresProductosGrid } from "@/erp/clientes/fibra-optica/shared/components/form/rubros";
import { MaterialTransferidoInventarioCorporativo } from "@/erp/contabilidad/clientes-corporativos/pages/ClientesCoorporativosSave";
import { CustomTabPanel } from "@/erp/sale";
import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import {
  a11yProps,
  BucketAwtENUM,
  EstadoFactibilidadCorporativaENUM,
  gridSizeConst3,
  gridSizeMdLg12,
  gridSizeMdLg6,
  ModulosEnumChoice,
  ROUTER_PATHS,
  useLoaders,
  useUploadFile,
} from "@/shared";
import {
  useFetchGetByIdfactibilidadCorporativos,
  useFetchPutFactibilidadCorporativo,
} from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { usePutPlanCorporativo } from "@/shared/actions/erp/planes";
import { fetchPutPreventaCorporativo } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import {
  CustomAutocompleteNoForm,
  CustomTextFieldNoForm,
  DropzoneFiles,
  FormTabsOnly,
  NestedTabsScene,
  PDFReader,
  SampleTable,
} from "@/shared/components/ui";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { useModalMotivoRechazo } from "@/shared/components/ui/ModalMotivoRechazo/useModalMotivoRechazo";
import {
  AlertSeverityEnum,
  CategoriaFCorporativaEnum,
} from "@/shared/interfaces";
import { CondicionVentaCorporativa } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
// import { AlertSeverityEnum } from "@/shared/interfaces";
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import { useUiConfirmModalStore } from "@/store/ui";
import {
  Button,
  Grid,
  Tab,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
// import copy from "copy-to-clipboard";
import { MRT_ColumnDef } from "material-react-table";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { useUiStore } from "@/store/ui";

// type MaterialTransferidoInventarioCorporativo = {
//   codigo?:string;
//   nombre?:string;
//   precioUnitario?:number;
//   cantidad?:number;
//   total?:number;
//   ivaValue?:number;
//   ivaCode?:string;
//   precioLibre?:boolean;
//   preciosDisponibles?:IPreciosProductos[];

//   incremento?:number;
//   valor_costo_instalacion?: number;
// }

export default function SolicitudesPendientesCorporativosEdit() {
  const { idsolicitudespendientes } = useParams();
  const navigate = useNavigate();
  const returnUrl =
    ROUTER_PATHS.ventasCorporativas.solicitudesPendientesCorporativoNav;

  const [newValorInstalacion, setNewValorInstalacion] = useState("0");
  const [utltimaCorreccion, setUtltimaCorreccion] = useState<any>({});
  const [valueTabDocs, setValueTabDocs] = useState(1);
  const [openUploadDocuments, setOpenUploadDocuments] =
    useState<boolean>(false);
  const [docAnexo1, setDocAnexo1] = useState<File | null>(null);
  const [docAnexo2, setDocAnexo2] = useState<File | null>(null);
  const [currentVisibleFile, setCurrentVisibleFile] = useState<string>("");
  const handleMethodChangeDocsTab = (_event: any, newValue: number) => {
    setValueTabDocs(newValue);
    setCurrentVisibleFile("");
  };

  ///* global state
  // const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  // const setConfirmDialogIsOpen = useUiConfirmModalStore(s => s.setConfirmDialogIsOpen);
  const setAlert = useUiStore((s) => s.setAlert);
  const selectedItems: MaterialTransferidoInventarioCorporativo[] =
    useMaterialesUtilizadosStore((s) => s.selectedItems);

  const addSelectedItem = useMaterialesUtilizadosStore(
    (s) => s.addSelectedItemCustomKey,
  );

  const clearSelectedItems = useMaterialesUtilizadosStore(
    (s) => s.clearSelectedItems,
  );
  const updateSelectedItemQuantity = useMaterialesUtilizadosStore(
    (s) => s.updateSelectedItemQuantity,
  );
  ///servicio adicional
  const addSelectedItemProducto = useMaterialesUtilizadosStore(
    (s) => s.addSelectedItemProducto,
  );
  const ingresoProductos = useMaterialesUtilizadosStore(
    (s) => s.ingresoProductos,
  );
  //equipos adicional
  const addSelectedItemEquipoAdicional = useMaterialesUtilizadosStore(
    (s) => s.addProductoSinSeriesItem,
  );
  const productosEquiposAdicionales = useMaterialesUtilizadosStore(
    (s) => s.equiposAdicionales,
  );

  const form = useForm<any>({});
  const form2 = useForm<any>({});

  // const setAlert = useUiStore(s => s.setAlert);
  const {
    data: SolucionCosteadaPagingRes,
    isLoading: isfcSolucionCosteada,
    // isRefetching: isRefetchingFactCoorporativa,
  } = useFetchGetByIdfactibilidadCorporativos(idsolicitudespendientes!);
  const {
    mutateAsync: updateFCorporativa,
    // isRefetching: isRefetchingFactCoorporativa,
  } = useFetchPutFactibilidadCorporativo({
    enableSuccessAlert: true,
  });

  const { mutateAsync: mutateAsyncPutPlanCorporativo } = usePutPlanCorporativo(
    {},
  );
  const { mutateAsync: mutateAsyncPutPreventaCorporativa } =
    fetchPutPreventaCorporativo({});

  const { mutateAsync: mutateAsyncPutPreventaCorporativo } =
    fetchPutPreventaCorporativo({
      enableSuccessAlert: true,
    });

  const { handleUploadFile } = useUploadFile();

  const updateFactibilidadCorporativa = useFetchPutFactibilidadCorporativo({
    navigate: navigate,
    returnUrl: returnUrl,
  });
  //
  useEffect(() => {
    clearSelectedItems(MaterialesKey.ingresoProductos);
    clearSelectedItems(MaterialesKey.equiposAdicionales);
    if (
      !SolucionCosteadaPagingRes?.data?.preventa_corporativa_data
        ?.servicios_adicionales?.length
    )
      return;
    const servicios =
      SolucionCosteadaPagingRes.data?.preventa_corporativa_data
        ?.servicios_adicionales;
    if (!servicios?.length) return;
    addSelectedItemProducto(servicios, MaterialesKey.ingresoProductos, false);
    if (!SolucionCosteadaPagingRes.data?.detalles?.length) return;
    addSelectedItemEquipoAdicional(
      SolucionCosteadaPagingRes?.data?.detalles,
      MaterialesKey.equiposAdicionales,
      false,
    );
  }, [SolucionCosteadaPagingRes]);
  //
  const handleKeyDown = (e: any) => {
    const key = e.key;
    // Bloquea la tecla de guion, letras y teclas especiales
    if (
      (key === "-" || key === "e" || /[^0-9]/.test(key)) &&
      ![
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Backspace",
        "Tab",
      ].includes(e.key)
    ) {
      e.preventDefault(); // Evita que se ingrese la tecla no permitida
    }
  };

  const calcTotalLine = (
    item: MaterialTransferidoInventarioCorporativo,
  ): string => {
    return (
      (
        +(item.precioUnitario || 0) *
        +(item.cantidad || 0) *
        // (+(item.incremento || 0) / 100 + 1) *
        (+(item.ivaValue || 0) / 100 + 1)
      ).toFixed(2) || ""
    );
  };
  const calcSubTotalLine = (
    item: MaterialTransferidoInventarioCorporativo,
  ): string => {
    return (
      (+(item.precioUnitario || 0) * +(item.cantidad || 0)).toFixed(2) || ""
    );
  };

  const onChangePrice = useCallback(
    (value: string, item: MaterialTransferidoInventarioCorporativo) => {
      // let valor = calcTotalLine({
      //   ...item,
      //   precioUnitario: +value,
      // })
      updateSelectedItemQuantity(
        {
          ...item,
          precioUnitario: value,

          total: calcTotalLine({
            ...item,
            precioUnitario: +value,
          }),
          subtotal: calcSubTotalLine({
            ...item,
            precioUnitario: +value,
          }),
        },
        MaterialesKey.selectedItems,
        "codigo",
      );
    },
    [updateSelectedItemQuantity],
  );

  //
  const productoServiciosAdicionales = () => {
    if (!ingresoProductos?.length) return [];

    const serviciosSeleccionados = new Map(
      selectedItems
        .filter((item) => item.codigo)
        .map((item) => [String(item.codigo), item]),
    );
    const productos = Array.isArray(ingresoProductos[0])
      ? ingresoProductos.flat()
      : ingresoProductos;

    return productos.map((item) => {
      const key = item.codigo ? String(item.codigo) : "";
      const updated = key ? serviciosSeleccionados.get(key) : undefined;

      if (!updated || updated.precioUnitario === undefined) return item;

      const precioUnitario = Number(updated.precioUnitario);
      if (!Number.isFinite(precioUnitario)) return item;

      return {
        ...item,
        precioUnitario,
      };
    });
  };

  const EquiposAdicionales = () => {
    if (!productosEquiposAdicionales?.length) return [];

    const serviciosSeleccionados = new Map(
      selectedItems
        .filter((item) => item.codigo)
        .map((item) => [String(item.codigo), item]),
    );
    const productos = (
      Array.isArray(productosEquiposAdicionales[0])
        ? productosEquiposAdicionales.flat()
        : productosEquiposAdicionales
    ) as Array<
      MaterialTransferidoInventarioCorporativo & {
        producto_data?: {
          precios?: Array<{
            precio?: string | number;
          }>;
        };
      }
    >;

    return productos.map((item) => {
      const key = item.codigo ? String(item.codigo) : "";
      const updated = key ? serviciosSeleccionados.get(key) : undefined;

      const precioActualizado =
        updated?.precioUnitario ?? item.producto_data?.precios?.[0]?.precio;
      if (precioActualizado === undefined) return item;

      const precioUnitario = Number(precioActualizado);
      if (!Number.isFinite(precioUnitario)) return item;

      return {
        ...item,
        precioUnitario,
      };
    });
  };

  const actualizarValoresDeEnlace = async () => {
    const preventaCorporativa =
      SolucionCosteadaPagingRes?.data?.preventa_corporativa_data;
    const planPersonalizadoData =
      SolucionCosteadaPagingRes?.data?.preventa_corporativa_data
        ?.data_plan_personalizado;
    const planData = SolucionCosteadaPagingRes?.data?.plan_data;

    const selectedPlanItem = selectedItems.find(
      (x) =>
        x.nombre == planPersonalizadoData?.nombre_personalizado ||
        x.nombre == planData?.nombre,
    );
    const selectedValorInstalacionItem = selectedItems.find((x) =>
      x.nombre?.includes("VALOR DE INSTALACIÓN"),
    );
    const newDataPlanPersonalizado = {
      ...preventaCorporativa?.data_plan_personalizado,
      valor_personalizado: selectedPlanItem?.precioUnitario,
      costo_instalacion_personalizado:
        selectedValorInstalacionItem?.precioUnitario,
    };

    const selectedItemsByCodigo = new Map(
      (selectedItems || []).map((item) => [item.codigo, item]),
    );

    const newProductosCosteados = (
      SolucionCosteadaPagingRes?.data?.productos_costeados || []
    ).map((item: any) => {
      const updatedItem = selectedItemsByCodigo.get(item?.codigo);
      const productStoreItem = updatedItem ? { ...item, ...updatedItem } : item;

      if (
        productStoreItem?.nombre ==
          planPersonalizadoData?.nombre_personalizado ||
        productStoreItem?.nombre == planData?.nombre
      ) {
        productStoreItem.total = selectedPlanItem?.precioUnitario || 0;
        productStoreItem.subtotal = selectedPlanItem?.precioUnitario || 0;
        productStoreItem.precioUnitario = selectedPlanItem?.precioUnitario || 0;
      }
      if (productStoreItem?.nombre == "VALOR DE INSTALACIÓN") {
        productStoreItem.total =
          selectedValorInstalacionItem?.precioUnitario || 0;
        productStoreItem.subtotal =
          selectedValorInstalacionItem?.precioUnitario || 0;
        productStoreItem.precioUnitario =
          selectedValorInstalacionItem?.precioUnitario || 0;
      }
      return productStoreItem;
    });

    if (selectedPlanItem?.nombre && selectedValorInstalacionItem?.nombre) {
      await mutateAsyncPutPlanCorporativo({
        id: planData?.id_plan_coorporativo!,
        data: {
          costo_instalacion: selectedValorInstalacionItem?.precioUnitario || 0,
          valor: selectedPlanItem?.precioUnitario || 0,
        },
      });
      await mutateAsyncPutPreventaCorporativa({
        id_preventa_coorporativa: preventaCorporativa?.id_preventa_coorporativa,
        data_plan_personalizado: newDataPlanPersonalizado,
        valor_plan: selectedPlanItem?.precioUnitario,
        servicios_adicionales: productoServiciosAdicionales(),
      });
    }
    return newProductosCosteados;
  };

  const solicitarAprobacionInventario = async () => {
    const dataProductos = await actualizarValoresDeEnlace(); //por si cambia valores de plan o instalación

    updateFCorporativa({
      id_factibilidad_coorporativa:
        SolucionCosteadaPagingRes?.data.id_factibilidad_coorporativa,
      estado_factibilidad: EstadoFactibilidadCorporativaENUM.EN_REVISION,
      aprobado_supervisor: true,
      revisado_supervisor: true,
      valor_costo_instalacion: parseFloat(newValorInstalacion) || 0,
      valor_instalacion: parseFloat(newValorInstalacion) || 0,
      productos_costeados: dataProductos,
    });
    setAlert(
      true,
      "Solución costeada enviada para aprobación por inventario.",
      AlertSeverityEnum.success,
    );
  };

  const calcTotal = (): string => {
    // const allItems : MaterialTransferidoInventarioCorporativo[] = SolucionCosteadaPagingRes?.data.productos_costeados
    return selectedItems
      .filter(
        (x) =>
          x.categoria_fcorporativa !=
          CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
      )
      .reduce(
        (acc, item) =>
          acc +
          +(item.precioUnitario || 0) *
            +(item.cantidad || 0) *
            (+(item.incremento || 0) / 100 + 1) *
            (+(item.ivaValue || 0) / 100 + 1),
        0,
      )
      .toFixed(2);
  };

  const calcSubTotal = (): string => {
    // const costoMaterialesEquipos = selectedItems
    //   .reduce(
    //     (acc, item) =>
    //       acc + (item.precioUnitario || 0) * (item.cantidad || 0) * (+(item.incremento || 0) / 100 + 1),
    //     0
    //   )
    //   .toFixed(2);

    // const costoServiciosAdicionalesCorporativo = valoresServiciosAdicionalesCorporativos
    //   .reduce(
    //     (acc, item) =>
    //       acc + (item.precioUnitario || 0) * (item.cantidad || 0),
    //     0
    //   )
    //   .toFixed(2);

    // const costoPlanCorporativo = valoresPlanesCorporativos
    //   .reduce(
    //     (acc, item) =>
    //       acc + (item.precioUnitario || 0) * (item.cantidad || 0),
    //     0
    //   )
    //   .toFixed(2);

    // const allItems : MaterialTransferidoInventarioCorporativo[] = SolucionCosteadaPagingRes?.data.productos_costeados
    return selectedItems
      .filter(
        (x) =>
          x.categoria_fcorporativa !=
          CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
      )
      .reduce(
        (acc, item) =>
          acc +
          (item.precioUnitario || 0) *
            (item.cantidad || 0) *
            (+(item.incremento || 0) / 100 + 1),
        0,
      )
      .toFixed(2);
    // (parseFloat(costoMaterialesEquipos) + parseFloat(costoPlanCorporativo) + parseFloat(costoServiciosAdicionalesCorporativo)).toString()
  };

  const calcTotalTaxes = (): string => {
    // const allItems : MaterialTransferidoInventarioCorporativo[] = SolucionCosteadaPagingRes?.data.productos_costeados
    // selectedItems.concat(valoresServiciosAdicionalesCorporativos).concat(valoresPlanesCorporativos)
    return selectedItems
      .filter(
        (x) =>
          x.categoria_fcorporativa !=
          CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
      )
      .reduce(
        (acc, item) =>
          acc +
          +(item.precioUnitario || 0) *
            +(item.cantidad || 0) *
            (+(item.ivaValue || 0) / 100),
        0,
      )
      .toFixed(2);
  };

  const useHookModalMotivoCorreccion = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.FACTIBILIDAD_CORPORATIVO,
    // returnUrlFactibilidadCorp: ROUTER_PATHS.marketing.solucionSolicitudesCanjeEventoNav
  });
  const useHookModalMotivoCancelacion = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.FACTIBILIDAD_CORPORATIVO,
    option: EstadoFactibilidadCorporativaENUM.CANCELADO,
    // returnUrlFactibilidadCorp: ROUTER_PATHS.marketing.solucionSolicitudesCanjeEventoNav
  });

  /* const { fileInputRef} = useUploadFile() */

  useEffect(() => {
    clearSelectedItems(MaterialesKey.selectedItems);
    if (SolucionCosteadaPagingRes?.code == 200) {
      // Validación: Si es factibilidad de backup (es_backup=true),
      // los productos de categoría VALORESPLAN deben tener precio 0
      const esBackup = SolucionCosteadaPagingRes?.data?.es_backup;

      const auxAllItems: MaterialTransferidoInventarioCorporativo[] =
        SolucionCosteadaPagingRes?.data
          ?.productos_costeados as MaterialTransferidoInventarioCorporativo[];
      auxAllItems.map((x) => {
        // Si es backup y es VALORESPLAN, forzar precio a 0
        if (
          esBackup &&
          x.categoria_fcorporativa === CategoriaFCorporativaEnum.VALORESPLAN
        ) {
          x.precioUnitario = 0;
          x.total = 0;
          x.subtotal = 0;
        }

        if (
          x.nombre?.toLowerCase()?.includes("instalación") ||
          x.nombre?.toLowerCase()?.includes("instalacion")
        ) {
          setNewValorInstalacion(
            esBackup ? "0" : x.precioUnitario?.toString()!,
          );
        }
        addSelectedItem(x, MaterialesKey.selectedItems, "codigo", false, false);
      });
      const lengthCorrecciones =
        SolucionCosteadaPagingRes?.data.observaciones
          ?.observacion_revision_supervisor?.length;
      setUtltimaCorreccion(
        SolucionCosteadaPagingRes?.data.observaciones
          ?.observacion_revision_supervisor?.[lengthCorrecciones - 1] || [],
      );
    }
  }, [SolucionCosteadaPagingRes?.data]);

  useEffect(() => {
    form.reset({
      ...form.getValues(),
      documentos_habilitantes:
        SolucionCosteadaPagingRes?.data?.documentos?.documentos_habilitantes,
    });
    form2.reset({
      ...form2.getValues(),
      documentos_contractuales:
        SolucionCosteadaPagingRes?.data?.documentos?.documentos_contractuales,
    });
  }, []);
  //}, [SolucionCosteadaPagingRes?.data]);

  // const solucionCosteadaFactibilidad = SolucionCosteadaPagingRes?.data
  // clearSelectedItems(MaterialesKey.selectedItems)
  // if(!Array.isArray(solucionCosteadaFactibilidad?.detalles))
  //   return
  // solucionCosteadaFactibilidad?.detalles?.forEach(element => {
  //   const precioUnitarioAux = parseFloat(element?.producto_data?.precios[0]?.precio) || 0;
  //   addSelectedItem(
  //     {
  //       codigo: element.codigo! || element.id!,
  //       nombre: element.nombre! || element.codigo!,
  //       precioUnitario: element.precioUnitario || precioUnitarioAux,
  //       cantidad: element.cantidad!,
  //       total: element.total || parseFloat(element.cantidad!)*precioUnitarioAux,
  //       ivaCode: element.ivaCode || "IVA 0%",
  //       ivaValue: element.ivaValue || 0, // 15% de 50
  //       precioLibre: element.precioLibre || true,
  //       preciosDisponibles: element.preciosDisponibles || element?.producto_data?.precios,
  //     },
  //     MaterialesKey.selectedItems, 'codigo', false, false
  //   );
  // });

  // const planChoosed = planesCorporativosGlobal.filter(x=>x.codigo==solucionCosteadaFactibilidad?.preventa_corporativa_data?.plan)
  // //Se añadenValores de Plan
  // const ValoresPlan : MaterialTransferidoInventarioCorporativo[] = []
  // ValoresPlan.push({
  //   codigo:solucionCosteadaFactibilidad?.preventa_corporativa_data?.plan,
  //   nombre:planChoosed[0].nombre||"Plan de Prueba",
  //   precioUnitario:solucionCosteadaFactibilidad.preventa_corporativa_data?.valor_plan,
  //   cantidad:1,
  //   total:solucionCosteadaFactibilidad.preventa_corporativa_data?.valor_plan,
  //   ivaValue:0,
  //   ivaCode:""
  // })
  // ValoresPlan.push({
  //   codigo:solucionCosteadaFactibilidad?.preventa_corporativa_data?.plan+"-instalacion",
  //   nombre:"Valor Instalación",
  //   precioUnitario:solucionCosteadaFactibilidad.preventa_corporativa_data?.valor_instalacion,
  //   cantidad:1,
  //   total:solucionCosteadaFactibilidad.preventa_corporativa_data?.valor_instalacion,
  //   ivaValue:0,
  //   ivaCode:""
  // })
  // addSelectedItem(
  //   ValoresPlan[1],
  //   MaterialesKey.selectedItems, 'codigo', false, false
  // );
  // setValoresPlanesCorporativos(ValoresPlan)

  // //añadir validacion para servicios que vayan a manejar valores
  // //añadir validacion para servicios que vayan a manejar valores
  // const ValoresServiciosAdicionales : MaterialTransferidoInventarioCorporativo[] = []
  // if(SolucionCosteadaPagingRes?.data.preventa_corporativa_data?.seguridad_perimetral){
  //   ValoresServiciosAdicionales.push({
  //     codigo:"SEGURIDAD_PERIMETRAL",
  //     nombre:"SEGURIDAD PERIMETRAL",
  //     precioUnitario:SolucionCosteadaPagingRes?.data.preventa_corporativa_data?.costo_seguridad_perimetral,
  //     cantidad:1,
  //     total:SolucionCosteadaPagingRes?.data.preventa_corporativa_data?.costo_seguridad_perimetral,
  //     ivaValue:0,
  //     ivaCode:""
  //   })
  // }
  // if(SolucionCosteadaPagingRes?.data?.preventa_corporativa_data?.wifi_gestionado){
  //   ValoresServiciosAdicionales.push({
  //     codigo:"WIFI_GESTIONADO",
  //     nombre:"WIFI GESTIONADO",
  //     precioUnitario:SolucionCosteadaPagingRes?.data.preventa_corporativa_data?.costo_wifi_gestionado,
  //     cantidad:1,
  //     total:SolucionCosteadaPagingRes?.data.preventa_corporativa_data?.costo_wifi_gestionado,
  //     ivaValue:0,
  //     ivaCode:""
  //   })
  // }
  // if(SolucionCosteadaPagingRes?.data?.preventa_corporativa_data?.cableado_interno){
  //   ValoresServiciosAdicionales.push({
  //     codigo:"CABLEADO_INTERNO",
  //     nombre:"CABLEADO INTERNO",
  //     precioUnitario:SolucionCosteadaPagingRes?.data.preventa_corporativa_data?.costo_cableado_interno,
  //     cantidad:1,
  //     total:SolucionCosteadaPagingRes?.data.preventa_corporativa_data?.costo_cableado_interno,
  //     ivaValue:0,
  //     ivaCode:""
  //   })
  // }
  // if(SolucionCosteadaPagingRes?.data?.preventa_corporativa_data?.equipos_adicionales &&
  //   SolucionCosteadaPagingRes?.data?.preventa_corporativa_data?.equipos_adicionales?.length>0
  // ){
  //   SolucionCosteadaPagingRes?.data?.preventa_corporativa_data?.equipos_adicionales?.map((x)=>{
  //     ValoresServiciosAdicionales.push({
  //       codigo: x.codigo,
  //       nombre: x.codigo,
  //       precioUnitario:parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
  //       cantidad:1,
  //       total:parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
  //       ivaValue:0,
  //       ivaCode:""
  //     })
  //   })
  // }
  // setValoresServiciosAdicionalesCorporativos(ValoresServiciosAdicionales)

  const columnsRevisionProductosContabilidad = useMemo<
    MRT_ColumnDef<MaterialTransferidoInventarioCorporativo>[]
  >(
    () => [
      {
        accessorKey: "nombre",
        header: "Nombre",
        size: 300,
      },

      {
        accessorKey: "precioUnitario",
        header: "Precio",
        size: 120,
        Cell: ({ row }) => {
          const isEditable =
            row.original.categoria_fcorporativa?.includes(
              CategoriaFCorporativaEnum.VALORESPLAN,
            ) ||
            row.original.categoria_fcorporativa?.includes(
              CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
            ) ||
            row.original.categoria_fcorporativa?.includes(
              CategoriaFCorporativaEnum.EQUIPOSADICIONALES,
            );

          if (!isEditable) {
            return row.original.precioUnitario;
          }

          // Prefer a controlled value coming from the row (or a local state if you need it)
          const currentValue = row.original.precioUnitario ?? "";

          return (
            <Grid item xs={12} sm={12}>
              <TextField
                variant="standard"
                value={currentValue} // ← controlled
                type="text"
                inputMode="decimal"
                onChange={(e) => {
                  const raw = e.target.value;

                  // Allow empty, integers, and up to 2 decimal places
                  // Also accept comma as decimal separator (common in Spanish locales)
                  const normalized = raw.replace(",", ".");
                  const regex = /^\d*\.?\d{0,2}$/;

                  if (raw === "" || regex.test(normalized)) {
                    // Keep the original typed character (comma or dot) if you want,
                    // or always store with dot:
                    const valueToStore = raw === "" ? "" : normalized;

                    setNewValorInstalacion(valueToStore);
                    onChangePrice(valueToStore, row.original);
                  }
                  // If the regex fails we simply ignore the keystroke → input stays the same
                }}
                onKeyDown={(e) => {
                  // Optional: block anything that is clearly not part of a number
                  // (you can remove this if handleKeyDown already does something useful)
                  const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                    "Home",
                    "End",
                  ];
                  if (allowedKeys.includes(e.key)) return;

                  // Allow digits, one dot/comma, and the usual modifiers
                  if (!/[\d.,]/.test(e.key) && !e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                  }
                }}
                InputProps={{
                  inputProps: {
                    style: { textAlign: "right" },
                    // min/step are ignored with type="text", so no need for them
                  },
                }}
              />
            </Grid>
          );
        },
      },
      {
        accessorKey: "cantidad",
        header: "Cantidad",
        size: 120,
      },
      {
        accessorKey: "ivaCode",
        header: "Imp %",
        size: 100,
        Cell: ({ row }) => {
          return row.original.ivaCode || "0%";
        },
      },
      {
        accessorKey: "incremento",
        header: "Incremento",
        size: 100,
        Cell: ({ row }) => `${row.original?.incremento || "0"}%`,
      },
      {
        accessorKey: "subtotal",
        header: "Sub-Total",
        size: 120,
      },
      {
        accessorKey: "total",
        header: "Total",
        size: 120,
      },
    ],
    [],
  );

  useLoaders(isfcSolucionCosteada);
  if (isfcSolucionCosteada) return null;

  return (
    <>
      <Typography variant="h5">Solicitud Factibilidad Corporativa</Typography>
      <Typography variant="h3">
        {
          SolucionCosteadaPagingRes?.data?.prospecto_corporativo_data
            ?.razon_social
        }
      </Typography>
      <Typography variant="h5">
        Identificación:{" "}
        {
          SolucionCosteadaPagingRes?.data?.prospecto_corporativo_data
            ?.identificacion
        }
      </Typography>
      {SolucionCosteadaPagingRes?.data?.preventa_corporativa_data
        ?.condicion_venta ? (
        <Typography variant="h5">
          Condición Venta:{" "}
          {
            SolucionCosteadaPagingRes?.data?.preventa_corporativa_data
              ?.condicion_venta
          }
        </Typography>
      ) : null}

      <Grid container spacing={3} mt={2} mb={1}>
        {/* ================== button popover ================== */}
        {/* <ClienteRubroLibrePopover contract={contract} form={form} /> */}
        <Grid xs={12} md={12} container justifyContent="flex-end">
          <Button
            onClick={() => {
              clearSelectedItems(MaterialesKey.selectedItems);
              clearSelectedItems(MaterialesKey.ingresoProductos);
              clearSelectedItems(MaterialesKey.equiposAdicionales);
              if (
                SolucionCosteadaPagingRes?.data?.prospecto_corporativo_data
                  ?.condicion_venta == CondicionVentaCorporativa.CANJE ||
                SolucionCosteadaPagingRes?.data?.prospecto_corporativo_data
                  ?.condicion_venta == CondicionVentaCorporativa.EVENTO_GRATUITO
                // || SolucionCosteadaPagingRes?.data?.prospecto_corporativo_data
                //   ?.condicion_venta == CondicionVentaCorporativa.EVENTO_PAGADO
              ) {
                navigate(
                  ROUTER_PATHS.marketing.solucionSolicitudesCanjeEventoNav,
                );
              } else {
                navigate(returnUrl);
              }
            }}
            variant="outlined"
            sx={{
              py: 1,
              my: 0,
              marginX: 1,
            }}
            size="small"
          >
            Regresar
          </Button>
          <Button
            onClick={() => {
              useHookModalMotivoCancelacion.setModalCancelar(true);
              useHookModalMotivoCancelacion.setDialogContentText(
                `Indique el motivo de cancelación de la factibilidad corporativa y una observación`,
              );
              useHookModalMotivoCancelacion.setLabelMotivo(
                `Motivo de Cancelación`,
              );
              useHookModalMotivoCancelacion.reset({
                id: SolucionCosteadaPagingRes?.data
                  ?.id_factibilidad_coorporativa,
                observaciones:
                  SolucionCosteadaPagingRes?.data?.observacion_rechazo,
              });
              clearSelectedItems(MaterialesKey.ingresoProductos);
              clearSelectedItems(MaterialesKey.equiposAdicionales);
            }}
            variant="outlined"
            sx={{
              py: 1,
              my: 0,
              marginX: 1,
            }}
            size="small"
            color="error"
          >
            Rechazar
          </Button>
          {SolucionCosteadaPagingRes?.data.revisado_supervisor &&
          !SolucionCosteadaPagingRes?.data.aprobado_supervisor &&
          ((SolucionCosteadaPagingRes?.data.url_anexo_1 &&
            SolucionCosteadaPagingRes?.data.url_anexo_2) ||
            SolucionCosteadaPagingRes?.data.documentos?.documentos_habilitantes
              ?.length > 0 ||
            SolucionCosteadaPagingRes?.data.documentos?.documentos_contractuales
              ?.length > 0) ? (
            <Button
              onClick={async () => {
                const dataProductos = await actualizarValoresDeEnlace(); //por si cambia valores de plan o instalación
                const dataEquiposAdicionales = EquiposAdicionales(); //por si cambia valores de equipos adicionales
                useHookModalMotivoCorreccion.setModalCancelar(true);
                useHookModalMotivoCorreccion.setDialogContentText(
                  `Indique el motivo de corrección y una observación`,
                );
                useHookModalMotivoCorreccion.setLabelMotivo(
                  `Motivo de Corrección`,
                );
                useHookModalMotivoCorreccion.reset({
                  id: SolucionCosteadaPagingRes?.data
                    ?.id_factibilidad_coorporativa,
                  observaciones: SolucionCosteadaPagingRes?.data?.observaciones,
                  productos_costeados: dataProductos,
                  detalles: dataEquiposAdicionales,
                });
                clearSelectedItems(MaterialesKey.ingresoProductos);
                clearSelectedItems(MaterialesKey.equiposAdicionales);
              }}
              variant="contained"
              sx={{
                py: 1,
                my: 0,
                marginX: 1,
              }}
              size="small"
              color="error"
            >
              Enviar a Corregir
            </Button>
          ) : null}
          {SolucionCosteadaPagingRes?.data.revisado_supervisor &&
          SolucionCosteadaPagingRes?.data.aprobado_supervisor &&
          SolucionCosteadaPagingRes?.data.url_anexo_1 &&
          SolucionCosteadaPagingRes?.data.url_anexo_2 ? (
            <Tooltip
              placement="top"
              title="Inventario esta validando las existencias de los materiales y/o equipos requeridos"
            >
              <Button
                variant="outlined"
                sx={{
                  py: 1,
                  my: 0,
                  marginX: 1,
                }}
                size="small"
                color="success"
              >
                Validando por Inventario
              </Button>
            </Tooltip>
          ) : null}
          {!SolucionCosteadaPagingRes?.data?.revisado_supervisor &&
          SolucionCosteadaPagingRes?.data?.preaprobado_inventario &&
          SolucionCosteadaPagingRes?.data?.prospecto_corporativo_data
            ?.condicion_venta != CondicionVentaCorporativa.CANJE ? (
            <Button
              onClick={async () => {
                const dataProductos = await actualizarValoresDeEnlace(); //por si cambia valores de plan o instalación
                const dataEquiposAdicionales = EquiposAdicionales(); //por si cambia valores de equipos adicionales
                //return
                await updateFactibilidadCorporativa.mutateAsync({
                  id_factibilidad_coorporativa:
                    SolucionCosteadaPagingRes?.data
                      .id_factibilidad_coorporativa,
                  valor_costo_instalacion: parseFloat(newValorInstalacion) || 0,
                  estado_factibilidad:
                    EstadoFactibilidadCorporativaENUM.EN_REVISION,
                  revisado_supervisor: true,
                  productos_costeados: dataProductos,

                  ...(dataEquiposAdicionales.length > 0 && {
                    detalles: dataEquiposAdicionales,
                  }),
                  //detalles: dataEquiposAdicionales
                });
                clearSelectedItems(MaterialesKey.ingresoProductos);
                clearSelectedItems(MaterialesKey.equiposAdicionales);
              }}
              variant="contained"
              sx={{
                py: 1,
                my: 0,
                marginX: 1,
              }}
              size="small"
              color="success"
            >
              Solicitar Carga de Documentos
            </Button>
          ) : null}
          {(SolucionCosteadaPagingRes?.data.revisado_supervisor == true &&
            SolucionCosteadaPagingRes?.data.estado_factibilidad ==
              EstadoFactibilidadCorporativaENUM.EN_REVISION &&
            !SolucionCosteadaPagingRes?.data.aprobado_supervisor) ||
          SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
            ?.condicion_venta == CondicionVentaCorporativa.CANJE ||
          SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
            ?.condicion_venta == CondicionVentaCorporativa.EVENTO_GRATUITO ? (
            // || SolucionCosteadaPagingRes?.data.prospecto_corporativo_data?.condicion_venta == CondicionVentaCorporativa.EVENTO_PAGADO
            <>
              <Tooltip title="Subir Documentos">
                <Button
                  onClick={() => {
                    setOpenUploadDocuments(!openUploadDocuments);
                  }}
                  style={{
                    color: "#2F3746",
                  }}
                  startIcon={<ContentCopyIcon />}
                >
                  <span style={{ fontSize: "12px" }}>Documentos</span>
                </Button>
              </Tooltip>
              {SolucionCosteadaPagingRes?.data.preaprobado_inventario &&
              SolucionCosteadaPagingRes?.data.estado_factibilidad ==
                EstadoFactibilidadCorporativaENUM.EN_GESTION &&
              (SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                ?.condicion_venta == CondicionVentaCorporativa.CANJE ||
                SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                  ?.condicion_venta ==
                  CondicionVentaCorporativa.EVENTO_GRATUITO ||
                SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                  ?.condicion_venta ==
                  CondicionVentaCorporativa.EVENTO_PAGADO) ? (
                <>
                  <Button
                    variant="outlined"
                    onClick={() => solicitarAprobacionInventario()}
                    sx={{
                      py: 1,
                      my: 0,
                      marginX: 1,
                    }}
                    size="small"
                    color="success"
                  >
                    Solicitar Aprobación Inventario
                  </Button>
                </>
              ) : null}
              {SolucionCosteadaPagingRes?.data.estado_factibilidad ==
                EstadoFactibilidadCorporativaENUM.APROBADO &&
              SolucionCosteadaPagingRes?.data.revisado_supervisor &&
              SolucionCosteadaPagingRes?.data.aprobado_inventario &&
              !SolucionCosteadaPagingRes?.data.factibilidad_enviada &&
              (SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                ?.condicion_venta == CondicionVentaCorporativa.CANJE ||
                SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                  ?.condicion_venta ==
                  CondicionVentaCorporativa.EVENTO_GRATUITO ||
                SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                  ?.condicion_venta ==
                  CondicionVentaCorporativa.EVENTO_PAGADO) ? (
                <Button
                  onClick={() => {
                    actualizarValoresDeEnlace(); //por si cambia valores de plan o instalación
                    updateFCorporativa({
                      id_factibilidad_coorporativa:
                        SolucionCosteadaPagingRes?.data
                          .id_factibilidad_coorporativa,
                      factibilidad_enviada: true,
                    });
                  }}
                  variant="outlined"
                  sx={{
                    py: 1,
                    my: 0,
                    marginX: 1,
                  }}
                  size="small"
                  color="success"
                >
                  Enviar a Gestionar Agendamiento
                </Button>
              ) : null}
              {SolucionCosteadaPagingRes?.data.factibilidad_enviada ? (
                <Button
                  variant="outlined"
                  sx={{
                    py: 1,
                    my: 0,
                    marginX: 1,
                  }}
                  size="small"
                  color="success"
                  disabled={true}
                >
                  Enviada a Agendamiento
                </Button>
              ) : null}
            </>
          ) : null}
          {SolucionCosteadaPagingRes?.data.revisado_supervisor &&
          (SolucionCosteadaPagingRes?.data.estado_factibilidad ==
            EstadoFactibilidadCorporativaENUM.CORREGIDO ||
            SolucionCosteadaPagingRes?.data.estado_factibilidad ==
              EstadoFactibilidadCorporativaENUM.DOCUMENTOS_CARGADOS) &&
          ((SolucionCosteadaPagingRes?.data.url_anexo_1 &&
            SolucionCosteadaPagingRes?.data.url_anexo_2) ||
            SolucionCosteadaPagingRes?.data.documentos?.documentos_habilitantes
              ?.length > 0 ||
            SolucionCosteadaPagingRes?.data.documentos?.documentos_contractuales
              ?.length > 0) ? (
            // && SolucionCosteadaPagingRes?.data.url_anexo_3
            // && SolucionCosteadaPagingRes?.data.url_orden_servicio
            <Button
              onClick={async () => {
                const dataProductos = await actualizarValoresDeEnlace(); //por si cambia valores de plan o instalación
                const dataEquiposAdicionales = EquiposAdicionales(); //por si cambia valores de equipos adicionales
                updateFactibilidadCorporativa.mutate({
                  id_factibilidad_coorporativa:
                    SolucionCosteadaPagingRes?.data
                      .id_factibilidad_coorporativa,
                  estado_factibilidad:
                    EstadoFactibilidadCorporativaENUM.EN_REVISION,
                  valor_costo_instalacion: parseFloat(newValorInstalacion),
                  productos_costeados: dataProductos,

                  ...(dataEquiposAdicionales.length > 0 && {
                    detalles: dataEquiposAdicionales,
                  }),
                  //detalles: dataEquiposAdicionales,
                  aprobado_supervisor: true,
                });
              }}
              variant="contained"
              sx={{
                py: 1,
                my: 0,
                marginX: 1,
              }}
              size="small"
              color="success"
            >
              Aprobar
            </Button>
          ) : null}
        </Grid>
        {SolucionCosteadaPagingRes?.data.estado_factibilidad ==
          EstadoFactibilidadCorporativaENUM.EN_REVISION ||
        SolucionCosteadaPagingRes?.data.estado_factibilidad ==
          EstadoFactibilidadCorporativaENUM.CORREGIDO ? (
          <Grid
            item
            {...gridSizeMdLg12}
            justifyContent={"left"}
            textAlign={"left"}
          >
            <Typography variant="h6">Última novedad registrada</Typography>
            <Grid>
              <Grid>
                <span>
                  <b>Motivo: </b>
                </span>
                <span>{utltimaCorreccion?.motivo_rechazo || "N/A"}</span>
              </Grid>
              <Grid>
                <span>
                  <b>Observación: </b>
                </span>
                <span>
                  {utltimaCorreccion?.observacion_cancelacion || "N/A"}
                </span>
              </Grid>
              <Grid>
                <span>
                  <b>Fecha: </b>
                </span>
                <span>
                  {dayjs(utltimaCorreccion?.fecha).format("LLL") || "N/A"}
                </span>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
        {/* CARGAR DOCUMENTOS CUANDO ES CANJE */}
        {((SolucionCosteadaPagingRes?.data.revisado_supervisor &&
          SolucionCosteadaPagingRes?.data.estado_factibilidad ==
            EstadoFactibilidadCorporativaENUM.EN_REVISION) ||
          SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
            ?.condicion_venta == CondicionVentaCorporativa.CANJE) &&
          ((SolucionCosteadaPagingRes?.data.revisado_supervisor &&
            SolucionCosteadaPagingRes?.data.estado_factibilidad ==
              EstadoFactibilidadCorporativaENUM.EN_REVISION) ||
          (SolucionCosteadaPagingRes?.data.documentos &&
            (SolucionCosteadaPagingRes?.data.documentos?.documentos_habilitantes
              ?.length > 0 ||
              SolucionCosteadaPagingRes?.data.documentos
                ?.documentos_contractuales?.length > 0)) ? (
            <>
              <Grid
                container
                item
                xs={12}
                justifyContent={"center"}
                spacing={2}
                sx={{
                  display: openUploadDocuments ? "flex" : "none",
                }}
              >
                {/* <Grid item xs={12}>
                  <Typography variant="h6" p={2}>
                    Carga de Documentos
                  </Typography>
                  <TabTextLabel text="Si ya ha cargado los documentos previamente, realizar esta acción reemplazará los anteriores."/>
  
                </Grid> */}

                <Grid item {...gridSizeMdLg6}>
                  <DropzoneFiles
                    form={form}
                    titleCargaAnexos="Documentos Habilitantes"
                    sizeItem={gridSizeConst3}
                    keyForm="documentos_habilitantes"
                    bucket={
                      BucketAwtENUM.DOCUMENTOS_SOLUCION_COSTEADA_CORPORATIVA
                    }
                  />
                  {/* <CargaDocumentosSolucionCosteadaMultiple form={form} size={gridSizeMdLg12}
                  currentKeyForm="documentos_habilitantes"/> */}
                  {/* <CargarDocumentoSoluccionCosteada
                    idInput='anexo-1'
                    buttonText={'Documentos Habilitantes'}
                    selectedImage={docAnexo1}
                    setSelectedImage={setDocAnexo1}
  
                  /> */}
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <DropzoneFiles
                    form={form2}
                    titleCargaAnexos="Documentos Contractuales"
                    sizeItem={gridSizeConst3}
                    keyForm="documentos_contractuales"
                    bucket={
                      BucketAwtENUM.DOCUMENTOS_SOLUCION_COSTEADA_CORPORATIVA
                    }
                  />
                  {/* <CargaDocumentosSolucionCosteadaMultiple form={form} 
                  size={gridSizeMdLg12} currentKeyForm="documentos_contractuales"/> */}
                  {/* <CargarDocumentoSoluccionCosteada
                    idInput='anexo-2'
                    buttonText={'Documentos Contractuales'}
                    selectedImage={docAnexo2}
                    setSelectedImage={setDocAnexo2}
                  /> */}
                </Grid>

                <Grid
                  item
                  {...gridSizeMdLg12}
                  justifyContent={"center"}
                  textAlign={"end"}
                >
                  <Button
                    onClick={async () => {
                      const documentos_habilitantes =
                        form.getValues()?.documentos_habilitantes;
                      const documentos_contractuales =
                        form2.getValues()?.documentos_contractuales;

                      ///* Documentos pendientes por subir
                      if (
                        !documentos_habilitantes ||
                        documentos_habilitantes.length === 0 ||
                        !documentos_contractuales ||
                        documentos_contractuales.length === 0
                      )
                        return setAlert(
                          true,
                          "Suba al menos un documento en cada campo",
                          AlertSeverityEnum.info,
                        );

                      const sendDocumentos = {
                        documentos_habilitantes: documentos_habilitantes,
                        documentos_contractuales: documentos_contractuales,
                      };

                      try {
                        if (
                          sendDocumentos.documentos_habilitantes &&
                          sendDocumentos.documentos_contractuales
                        ) {
                          // =====================================================
                          // una vez cargados los documentos no se puede editar la información de la preventa
                          // =====================================================
                          mutateAsyncPutPreventaCorporativo({
                            id_preventa_coorporativa:
                              SolucionCosteadaPagingRes.data
                                .preventa_corporativa_data
                                ?.id_preventa_coorporativa,
                            permitir_edicion: false,
                          });
                          // =====================================================
                          // si es una venta de canje se guardan solo las urls
                          // =====================================================
                          if (
                            SolucionCosteadaPagingRes?.data
                              .prospecto_corporativo_data?.condicion_venta ==
                            CondicionVentaCorporativa.CANJE
                          ) {
                            updateFCorporativa({
                              documentos: sendDocumentos,
                              id_factibilidad_coorporativa:
                                SolucionCosteadaPagingRes?.data
                                  .id_factibilidad_coorporativa,
                            });
                          } else {
                            updateFCorporativa({
                              documentos: sendDocumentos,
                              id_factibilidad_coorporativa:
                                SolucionCosteadaPagingRes?.data
                                  .id_factibilidad_coorporativa,
                              estado_factibilidad:
                                SolucionCosteadaPagingRes?.data.observaciones
                                  ?.observacion_revision_supervisor?.length > 0
                                  ? EstadoFactibilidadCorporativaENUM.CORREGIDO
                                  : EstadoFactibilidadCorporativaENUM.DOCUMENTOS_CARGADOS,
                            });
                          }
                        } else {
                          return setAlert(
                            true,
                            "Error al cargar los documentos. Intente nuevamente.",
                            AlertSeverityEnum.warning,
                          );
                        }
                      } catch (error) {
                        return setAlert(
                          true,
                          "Error al cargar los documentos",
                          AlertSeverityEnum.error,
                        );
                      }
                    }}
                    variant="outlined"
                    sx={{
                      py: 1,
                      my: 0,
                      marginX: 1,
                    }}
                    size="small"
                    color="primary"
                  >
                    {SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                      ?.condicion_venta
                      ? "Cargar Documentos"
                      : "Enviar Documentos a Revisión"}
                  </Button>
                </Grid>
              </Grid>
            </>
          ) : !SolucionCosteadaPagingRes?.data?.url_anexo_1 ||
            SolucionCosteadaPagingRes?.data?.url_anexo_2 ? (
            <Grid
              container
              item
              xs={12}
              justifyContent={"center"}
              spacing={2}
              sx={{
                display: openUploadDocuments ? "flex" : "none",
              }}
            >
              {/* <Grid item {...gridSizeMdLg3}>
                    <IconButton onClick={() => {
                      // setOpenUploadDocuments(true)
                    }}>
                      <InsertDriveFileIcon />
                      <span style={{ fontSize: "12px" }}>Cargar Documento</span>
                    </IconButton>
                  </Grid> */}

              <Grid item xs={12}>
                <Typography variant="h6" p={2}>
                  Carga de Documentos
                </Typography>
                {/* <TabTextLabel text="Si ya ha cargado los documentos previamente, realizar esta acción reemplazará los anteriores." /> */}
              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <CargarDocumentoSoluccionCosteada
                  idInput="anexo-1"
                  buttonText={"Documentos Habilitantes"}
                  selectedImage={docAnexo1}
                  setSelectedImage={setDocAnexo1}
                />
              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <CargarDocumentoSoluccionCosteada
                  idInput="anexo-2"
                  buttonText={"Documentos Contractuales"}
                  selectedImage={docAnexo2}
                  setSelectedImage={setDocAnexo2}
                />
              </Grid>

              <Grid
                item
                {...gridSizeMdLg12}
                justifyContent={"center"}
                textAlign={"end"}
              >
                <Button
                  onClick={async () => {
                    const documentosFile = [docAnexo1, docAnexo2];

                    ///* Documentos pendientes por subir
                    if (documentosFile.some((e) => e == null))
                      return setAlert(
                        true,
                        "Documentos faltan por subir",
                        AlertSeverityEnum.info,
                      );

                    try {
                      const [respAnexo1, respAnexo2] = await Promise.all([
                        handleUploadFile(
                          docAnexo1!,
                          BucketAwtENUM.DOCUMENTOS_CORPORATIVO,
                        ),
                        handleUploadFile(
                          docAnexo2!,
                          BucketAwtENUM.DOCUMENTOS_CORPORATIVO,
                        ),
                      ]);

                      const sendDocumentos = {
                        url_anexo_1: respAnexo1.url,
                        url_anexo_2: respAnexo2.url,
                      };
                      if (
                        sendDocumentos.url_anexo_1 &&
                        sendDocumentos.url_anexo_2
                      ) {
                        // =====================================================
                        // una vez cargados los documentos no se puede editar la información de la preventa
                        // =====================================================
                        mutateAsyncPutPreventaCorporativo({
                          id_preventa_coorporativa:
                            SolucionCosteadaPagingRes.data
                              .preventa_corporativa_data
                              ?.id_preventa_coorporativa,
                          permitir_edicion: false,
                        });
                        // =====================================================
                        // si es una venta de canje se guardan solo las urls
                        // =====================================================
                        if (
                          SolucionCosteadaPagingRes?.data
                            .prospecto_corporativo_data?.condicion_venta ==
                          CondicionVentaCorporativa.CANJE
                        ) {
                          updateFCorporativa({
                            ...sendDocumentos,
                            id_factibilidad_coorporativa:
                              SolucionCosteadaPagingRes?.data
                                .id_factibilidad_coorporativa,
                          });
                        } else {
                          updateFCorporativa({
                            ...sendDocumentos,
                            id_factibilidad_coorporativa:
                              SolucionCosteadaPagingRes?.data
                                .id_factibilidad_coorporativa,
                            estado_factibilidad:
                              SolucionCosteadaPagingRes?.data.observaciones
                                ?.observacion_revision_supervisor?.length > 0
                                ? EstadoFactibilidadCorporativaENUM.CORREGIDO
                                : EstadoFactibilidadCorporativaENUM.DOCUMENTOS_CARGADOS,
                          });
                        }
                      } else {
                        return setAlert(
                          true,
                          "Error al cargar los documentos. Intente nuevamente.",
                          AlertSeverityEnum.warning,
                        );
                      }
                    } catch (error) {
                      return setAlert(
                        true,
                        "Error al cargar los documentos",
                        AlertSeverityEnum.error,
                      );
                    }
                  }}
                  variant="outlined"
                  sx={{
                    py: 1,
                    my: 0,
                    marginX: 1,
                  }}
                  size="small"
                  color="primary"
                >
                  {SolucionCosteadaPagingRes?.data.prospecto_corporativo_data
                    ?.condicion_venta
                    ? "Cargar Documentos"
                    : "Enviar Documentos a Revisión"}
                </Button>
              </Grid>
            </Grid>
          ) : null)}

        {/* ================== Visualización de Documentos ================== */}
        {SolucionCosteadaPagingRes?.data.documentos &&
        (SolucionCosteadaPagingRes?.data.documentos?.documentos_habilitantes
          ?.length > 0 ||
          SolucionCosteadaPagingRes?.data.documentos?.documentos_contractuales
            ?.length > 0) ? (
          <Grid container item xs={12} spacing={2}>
            <Typography variant="h5" p={2}>
              Documentos Cargados
            </Typography>
            <NestedTabsScene
              tabs={
                <FormTabsOnly
                  onChange={handleMethodChangeDocsTab}
                  value={valueTabDocs}
                >
                  <Tab
                    label="Documentos Habilitantes"
                    value={1}
                    {...a11yProps(1)}
                  />
                  <Tab
                    label="Documentos Contractuales"
                    value={2}
                    {...a11yProps(2)}
                  />
                  {/* <Tab label="ANEXO 3" value={3} {...a11yProps(3)} />
                    <Tab label="ANEXO ORDEN SERVICIO" value={4} {...a11yProps(4)} /> */}
                </FormTabsOnly>
              }
            >
              <CustomTabPanel index={valueTabDocs} value={1}>
                <Grid container spacing={2} {...gridSizeMdLg12}>
                  <Grid item {...gridSizeMdLg12}>
                    <CustomAutocompleteNoForm
                      label="Seleccione uno de los documentos habilitantes cargados"
                      options={SolucionCosteadaPagingRes?.data.documentos?.documentos_habilitantes?.map(
                        (item: any, index: number) => {
                          return {
                            name: item.name,
                            currentName: `Documento Habilitante ${index + 1}`,
                            url: item.url,
                          };
                        },
                      )}
                      valueKey="currentName"
                      actualValueKey="url"
                      onChangeValue={(value: any) => {
                        if (!value) {
                          setCurrentVisibleFile("");
                        }
                      }}
                      onChangeRawValue={(value: any) => {
                        setCurrentVisibleFile(value.url);
                      }}
                    />
                  </Grid>
                  <Grid item {...gridSizeMdLg12}>
                    {currentVisibleFile.includes(".pdf") ? (
                      <PDFReader
                        // fileUrl={`${SolucionCosteadaPagingRes?.data.url_anexo_1}?v=${new Date().getTime()}` || ''}
                        fileUrl={
                          `${currentVisibleFile}?v=${new Date().getTime()}` ||
                          ""
                        }
                      />
                    ) : currentVisibleFile ? (
                      <Grid item {...gridSizeMdLg12} textAlign={"center"}>
                        <a
                          href={currentVisibleFile}
                          download="Anexo1.xlsx"
                          target="_blank"
                        >
                          <Button variant="contained">
                            Descargar Documento
                          </Button>
                        </a>
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </CustomTabPanel>

              <CustomTabPanel index={valueTabDocs} value={2}>
                <Grid container spacing={2} {...gridSizeMdLg12}>
                  <Grid item {...gridSizeMdLg12}>
                    <CustomAutocompleteNoForm
                      label="Seleccione uno de los documentos contractuales cargados"
                      options={SolucionCosteadaPagingRes?.data.documentos?.documentos_contractuales?.map(
                        (item: any, index: number) => {
                          return {
                            name: item.name,
                            currentName: `Documento Contractual ${index + 1}`,
                            url: item.url,
                          };
                        },
                      )}
                      valueKey="currentName"
                      actualValueKey="url"
                      onChangeValue={(value: any) => {
                        if (!value) {
                          setCurrentVisibleFile("");
                        }
                      }}
                      onChangeRawValue={(value: any) => {
                        setCurrentVisibleFile(value.url);
                      }}
                    />
                  </Grid>
                  <Grid item {...gridSizeMdLg12}>
                    {currentVisibleFile.includes(".pdf") ? (
                      <PDFReader
                        // fileUrl={`${SolucionCosteadaPagingRes?.data.url_anexo_2}?v=${new Date().getTime()}` || ''}
                        fileUrl={
                          `${currentVisibleFile}?v=${new Date().getTime()}` ||
                          ""
                        }
                      />
                    ) : currentVisibleFile ? (
                      <Grid item {...gridSizeMdLg12} textAlign={"center"}>
                        <a href={currentVisibleFile} target="_blank">
                          <Button variant="contained">
                            Descargar Documento
                          </Button>
                        </a>
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </CustomTabPanel>
            </NestedTabsScene>
          </Grid>
        ) : // PAR VALIDAR EL CASO ANTERIOR A LA ACTUALIZACIÓN
        SolucionCosteadaPagingRes?.data.url_anexo_1 &&
          SolucionCosteadaPagingRes?.data.url_anexo_2 ? (
          // && SolucionCosteadaPagingRes?.data.url_anexo_3
          // && SolucionCosteadaPagingRes?.data.url_orden_servicio
          <>
            <Grid container item xs={12} spacing={2}>
              <Typography variant="h3" p={2}>
                Documentos Cargados
              </Typography>
              <NestedTabsScene
                tabs={
                  <FormTabsOnly
                    onChange={handleMethodChangeDocsTab}
                    value={valueTabDocs}
                  >
                    <Tab
                      label="Documentos Habilitantes"
                      value={1}
                      {...a11yProps(1)}
                    />
                    <Tab
                      label="Documentos Contractuales"
                      value={2}
                      {...a11yProps(2)}
                    />
                    {/* <Tab label="ANEXO 3" value={3} {...a11yProps(3)} />
                      <Tab label="ANEXO ORDEN SERVICIO" value={4} {...a11yProps(4)} /> */}
                  </FormTabsOnly>
                }
              >
                <CustomTabPanel index={valueTabDocs} value={1}>
                  {SolucionCosteadaPagingRes?.data.url_anexo_1.includes(
                    ".pdf",
                  ) ? (
                    <PDFReader
                      // fileUrl={`${SolucionCosteadaPagingRes?.data.url_anexo_1}?v=${new Date().getTime()}` || ''}
                      fileUrl={
                        `${
                          SolucionCosteadaPagingRes?.data.url_anexo_1
                        }?v=${new Date().getTime()}` || ""
                      }
                    />
                  ) : (
                    <Grid item {...gridSizeMdLg12} textAlign={"center"}>
                      <a
                        href={SolucionCosteadaPagingRes?.data.url_anexo_1}
                        download="Anexo1.xlsx"
                      >
                        <Button variant="contained">Descargar Documento</Button>
                      </a>
                    </Grid>
                  )}
                </CustomTabPanel>

                <CustomTabPanel index={valueTabDocs} value={2}>
                  {SolucionCosteadaPagingRes?.data.url_anexo_2.includes(
                    ".pdf",
                  ) ? (
                    <PDFReader
                      // fileUrl={`${SolucionCosteadaPagingRes?.data.url_anexo_2}?v=${new Date().getTime()}` || ''}
                      fileUrl={
                        `${
                          SolucionCosteadaPagingRes?.data.url_anexo_2
                        }?v=${new Date().getTime()}` || ""
                      }
                    />
                  ) : (
                    <Grid item {...gridSizeMdLg12} textAlign={"center"}>
                      <a href={SolucionCosteadaPagingRes?.data.url_anexo_2}>
                        <Button variant="contained">Descargar Documento</Button>
                      </a>
                    </Grid>
                  )}
                </CustomTabPanel>

                {/* <CustomTabPanel index={valueTabDocs} value={3}>
                    {
                      SolucionCosteadaPagingRes?.data.url_anexo_3.includes(".pdf") ?
                        <PDFReader
                          // fileUrl={`${SolucionCosteadaPagingRes?.data.url_anexo_3}?v=${new Date().getTime()}` || ''}
                          fileUrl={`${SolucionCosteadaPagingRes?.data.url_anexo_3}?v=${new Date().getTime()}` || ''}
                        />
                        :
                        <Grid item {...gridSizeMdLg12} textAlign={"center"}>
                          <a href={SolucionCosteadaPagingRes?.data.url_anexo_3}>
                            <Button variant="contained">Descargar Documento</Button>
                          </a>
                        </Grid>
                    }
                  </CustomTabPanel> */}

                {/* <CustomTabPanel index={valueTabDocs} value={4}>
                    {
                      SolucionCosteadaPagingRes?.data.url_orden_servicio.includes(".pdf") ?
                        <PDFReader
                          // fileUrl={`${SolucionCosteadaPagingRes?.data.url_orden_servicio}?v=${new Date().getTime()}` || ''}
                          fileUrl={`${SolucionCosteadaPagingRes?.data.url_orden_servicio}?v=${new Date().getTime()}` || ''}
                        />
                        :
                        <Grid item {...gridSizeMdLg12} textAlign={"center"}>
                          <a href={SolucionCosteadaPagingRes?.data.url_orden_servicio}>
                            <Button variant="contained">Descargar Documento</Button>
                          </a>
                        </Grid>
                    }

                  </CustomTabPanel> */}
              </NestedTabsScene>
            </Grid>
          </>
        ) : null}

        {/* ================== items table ================== */}
        <Grid item xs={12}>
          <Typography variant="h6" p={2}>
            Materiales y Equipos de Instalación
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnsRevisionProductosContabilidad}
            // data={selectedItems?.filter(x=>x.nombre?.toLowerCase()!=="valor instalación")||[]}
            data={
              selectedItems.filter(
                (x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa ==
                  CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
              ) || []
            }
            isLoading={isfcSolucionCosteada}
          />
        </Grid>

        {/* ================== items equipos adicionales table ================== */}
        <Grid item xs={12}>
          <Typography variant="h3" p={2}>
            Detalles
          </Typography>
          <Typography variant="h6" p={2}>
            Equipos Adicionales
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnsRevisionProductosContabilidad}
            data={
              selectedItems?.filter(
                (x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa ==
                  CategoriaFCorporativaEnum.EQUIPOSADICIONALES,
              ) || []
            }
          />
        </Grid>

        {/* ================== items servicios adicionales table ================== */}
        <Grid item xs={12}>
          <Typography variant="h6" p={2}>
            Servicios Adicionales
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnsRevisionProductosContabilidad}
            // data={valoresServiciosAdicionalesCorporativos || []}
            data={
              selectedItems?.filter(
                (x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa ==
                  CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
              ) || []
            }
            isLoading={isfcSolucionCosteada}
          />
        </Grid>

        {/* ================== items valores del plan table ================== */}
        <Grid item xs={12}>
          <Typography variant="h6" p={2}>
            Valores del Plan
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnsRevisionProductosContabilidad}
            data={
              selectedItems?.filter(
                (x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa ==
                  CategoriaFCorporativaEnum.VALORESPLAN,
              ) || []
            }
            isLoading={isfcSolucionCosteada}
          />
        </Grid>

        <Grid item {...gridSizeMdLg12}>
          <Typography variant="h6" p={2}>
            Detalles del Plan
          </Typography>
        </Grid>

        <Grid item container spacing={2} p={2} {...gridSizeMdLg12}>
          <CustomTextFieldNoForm
            label="Nombre"
            defaultValue={
              SolucionCosteadaPagingRes?.data.preventa_corporativa_data
                ?.data_plan_personalizado?.nombre_personalizado
            }
            size={gridSizeMdLg6}
            disabled={true}
          />
          <CustomTextFieldNoForm
            label="Permanencia"
            defaultValue={
              SolucionCosteadaPagingRes?.data.preventa_corporativa_data
                ?.data_plan_personalizado?.permanencia_personalizado
            }
            size={gridSizeMdLg6}
            disabled={true}
          />

          <CustomTextFieldNoForm
            label={"Capacidad (Mbps)"}
            value={
              SolucionCosteadaPagingRes?.data.preventa_corporativa_data
                ?.data_plan_personalizado?.capacidad_personalizado
            }
            size={gridSizeMdLg6}
            disabled={true}
          />

          <CustomTextFieldNoForm
            label={"Bonificación (Mbps)"}
            value={
              SolucionCosteadaPagingRes?.data.preventa_corporativa_data
                ?.data_plan_personalizado?.bonificacion_personalizado || 0
            }
            size={gridSizeMdLg6}
            disabled={true}
          />
          <CustomTextFieldNoForm
            label="Tipo"
            defaultValue={
              SolucionCosteadaPagingRes?.data.preventa_corporativa_data
                ?.tipo_plan
            }
            size={gridSizeMdLg6}
            disabled={true}
          />
        </Grid>

        {/* ================== total ================== */}
        <TotalValoresProductosGrid
          calcSubTotal={calcSubTotal}
          calcTotalTaxes={calcTotalTaxes}
          calcTotal={calcTotal}
        />

        {/* PRV-002: Sección Información Adicional (Solo Lectura) */}
        {(SolucionCosteadaPagingRes?.data?.area_responsable_inspeccion ||
          SolucionCosteadaPagingRes?.data
            ?.url_archivo_inspeccion_adicional) && (
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "2px solid #1976d2",
                paddingBottom: 1,
                marginBottom: 2,
              }}
            >
              Información Adicional
            </Typography>
            <Grid container spacing={2}>
              {SolucionCosteadaPagingRes?.data?.area_responsable_inspeccion && (
                <Grid item xs={12} md={6}>
                  <CustomTextFieldNoForm
                    label="Área Responsable"
                    value={
                      SolucionCosteadaPagingRes.data.area_responsable_inspeccion
                    }
                    disabled
                    shrink
                  />
                </Grid>
              )}
              {SolucionCosteadaPagingRes?.data
                ?.url_archivo_inspeccion_adicional && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <a
                    target="_blank"
                    href={
                      SolucionCosteadaPagingRes.data
                        .url_archivo_inspeccion_adicional
                    }
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: "primary.main",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Ver/Descargar Documento de Inspección
                    </Typography>
                  </a>
                </Grid>
              )}
              {SolucionCosteadaPagingRes?.data
                ?.url_archivo_propuesta_tecnica && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <a
                    target="_blank"
                    href={
                      SolucionCosteadaPagingRes.data
                        .url_archivo_propuesta_tecnica
                    }
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: "primary.main",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Ver/Descargar Documento de Propuesta Técnica
                    </Typography>
                  </a>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {/* FIN PRV-002 */}
      </Grid>

      {/* boton de rechazo */}
      <ModalMotivoRechazo {...useHookModalMotivoCorreccion} />
      <ModalMotivoRechazo {...useHookModalMotivoCancelacion} />
    </>
  );
}
